<template>
  <div class="mirco-app-report preview">
    <micro-app
      :name="microName"
      :url="getUrl"
      iframe
      router-mode="native"
      :baseroute="`/${microName}`"
      :data="storeInfo"
      keep-alive
      @datachange="handleDataChange"
    ></micro-app>
  </div>
</template>
<script lang="ts">
import microApp from '@micro-zoe/micro-app';
import configEnv from '@/config/user.env';
import { useStore } from 'vuex';
import { computed, defineComponent, nextTick, onMounted, reactive, ref, toRefs, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import eventBus from '@/utils/eventBus';
import { logout } from '@/utils/index';
import { handleMicroBigDataTrack } from '@/utils/bigLogData/trackHelper';

export default defineComponent({
  setup() {
    const storeInfo = ref({});
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
      path: '',
      query: {},
      applicationCode: '',
      visitedViews: [],
    });
    const store = useStore();

    const route = useRoute();
    const router = useRouter();
    const microName = 'microEam';

    watch(route, (val) => {
      initPage();
    });

    microApp.getData(microName);

    const getUrl = computed(() => {
      return configEnv.microEamUrl;
      // return 'https://localhost.annto.com:8080/';
    });

    const initPage = () => {
      const routeInfo = microApp.router.current.get(microName);
      if (routeInfo && microApp.router.decode(route.path).includes(microName)) {
        if (`/#${route.path}` !== routeInfo.fullPath) {
          // 把nextTick改成setTimeout可解决再去登录的时候，停留在我上个账号最后访问的页面问题
          setTimeout(() => {
            microApp.router.replace({ name: microName, path: `/#${route.fullPath}` });
          });
        }
      }

      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;
      state.applicationCode = store.state.applicationCode;
      state.path = route.path;
      state.query = route.query;
      state.visitedViews = store.getters.visitedViews;

      const { user, authority, currentTenant, appId, appList, btnPermissions, path, query, applicationCode, visitedViews } =
        toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        path,
        query,
        applicationCode,
        visitedViews,
        fullPath: route.fullPath,
      };
    };

    const handleDataChange = (val: any) => {
      const data = val.detail.data;
      if (handleMicroBigDataTrack(data, route.path)) return;
      // 子应用可以通过这个函数关闭当前页面
      if (data.type === 'closeActiveView') {
        const { view } = data;
        const findView = store.getters.visitedViews.find((item: any) => {
          return item.href === view.href;
          // return item.href.replace('#', '') === view.fullPath;
        });
        if (findView && findView.fullPath) {
          store.dispatch('delView', findView);
        }
      } else if (data.type === 'routes') {
        const { routes, lang } = data;
        store.commit('updateMicroRoutes', { microName, routes, lang });
        store.commit('UPDATE_VISITED_TITLE');
      } else if (data.type === 'logout') {
        logout();
      }
    };

    // 监听关闭标签事件
    const closeSelectedTag = (view: any) => {
      microApp.setData(microName, { type: 'closeSelectedTag', view });
    };
    eventBus.$on('closeSelectedTag', closeSelectedTag);

    onMounted(() => {
      // 记得修改子应用 id
      microApp.setData(microName, { path: route.path, query: route.query || {}, fullPath: route.fullPath });
      initPage();
    });

    return {
      microName,
      storeInfo,
      getUrl,
      handleDataChange,
    };
  },
});
</script>
<style lang="less" scoped>
.mirco-app-report {
  height: 100%;
  /deep/micro-app[name='microEam'] {
    width: 100%;
    height: 100%;
    micro-app-body {
      height: calc(100% - 10px);
      margin: 0px 10px;
      border-radius: 4px;
    }
    .microLayout {
      padding: 0 5px;
      height: 100%;
      & > div {
        height: 100%;
      }
    }
    .root-panel {
      height: 100%;
    }
    .el-dialog__wrapper {
      width: 100%;
      background: transparent;
    }
  }
}
</style>
